import React, { createContext, useContext, useState } from 'react';
import ConfirmDialog from '../components/ConfirmDialog';

const ConfirmContext = createContext();

export function ConfirmProvider({ children }) {
  const [confirmConfig, setConfirmConfig] = useState(null);
  const [resolveRef, setResolveRef] = useState(null);

  const confirm = (config) => {
    return new Promise((resolve) => {
      setConfirmConfig(config);
      setResolveRef(() => resolve);
    });
  };

  const handleClose = () => {
    setConfirmConfig(null);
    resolveRef?.(false);
  };

  const handleConfirm = () => {
    setConfirmConfig(null);
    resolveRef?.(true);
  };

  return (
    <ConfirmContext.Provider value={{ confirm }}>
      {children}
      <ConfirmDialog
        isOpen={!!confirmConfig}
        onClose={handleClose}
        onConfirm={handleConfirm}
        {...confirmConfig}
      />
    </ConfirmContext.Provider>
  );
}

export function useConfirm() {
  const context = useContext(ConfirmContext);
  if (!context) {
    throw new Error('useConfirm must be used within a ConfirmProvider');
  }
  return context;
} 